// [ADM STORAGE GRAFICO] Helper para formatar bytes em KB/MB/GB/TB
export function formatBytesToHumanReadable(bytes) {
  if (bytes === 0 || !Number.isFinite(bytes)) {
    return '0 KB';
  }

  const KB = 1024;
  const MB = KB * 1024;
  const GB = MB * 1024;
  const TB = GB * 1024;

  let value;
  let unit;

  if (bytes < MB) {
    // Até ~1 MB → KB
    value = bytes / KB;
    unit = 'KB';
  } else if (bytes < GB) {
    // Até ~1 GB → MB
    value = bytes / MB;
    unit = 'MB';
  } else if (bytes < TB) {
    // Até ~1 TB → GB
    value = bytes / GB;
    unit = 'GB';
  } else {
    // Muito grande → TB
    value = bytes / TB;
    unit = 'TB';
  }

  // Duas casas decimais, mas removendo zeros desnecessários (ex: 5.00 → 5)
  const formatted = value.toFixed(2);
  const trimmed = formatted.replace(/\.00$/, '');

  return `${trimmed} ${unit}`;
}
